var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.24 30L16.5 29L20.5 22H26.5C27.0304 22 27.5391 21.7893 27.9142 21.4142C28.2893 21.0391 28.5 20.5304 28.5 20V8C28.5 7.46957 28.2893 6.96086 27.9142 6.58579C27.5391 6.21071 27.0304 6 26.5 6H6.5C5.96957 6 5.46086 6.21071 5.08579 6.58579C4.71071 6.96086 4.5 7.46957 4.5 8V20C4.5 20.5304 4.71071 21.0391 5.08579 21.4142C5.46086 21.7893 5.96957 22 6.5 22H15.5V24H6.5C5.43913 24 4.42172 23.5786 3.67157 22.8284C2.92143 22.0783 2.5 21.0609 2.5 20V8C2.5 6.93913 2.92143 5.92172 3.67157 5.17157C4.42172 4.42143 5.43913 4 6.5 4H26.5C27.5609 4 28.5783 4.42143 29.3284 5.17157C30.0786 5.92172 30.5 6.93913 30.5 8V20C30.5 21.0609 30.0786 22.0783 29.3284 22.8284C28.5783 23.5786 27.5609 24 26.5 24H21.66L18.24 30Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10H24.5V12H8.5V10ZM8.5 16H18.5V18H8.5V16Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4949"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 32,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.7d19fb3645431e86229d42732e53fdd6.svg";
export { ForwardRef as ReactComponent };